import styled from '@emotion/styled';
import { Button, Typography } from '@mgmresorts/mgm-ui';

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledIconContainer = styled.div`
  padding-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  display: flex;
  justify-content: center;
`;

export const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledInfo = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  text-align: center;
`;

export const StyledContent = styled.div``;
